import type { IconType } from "@productlane/ui"
import { defaultAiChatExampleQuestions } from "@productlane/lib/src/ai-chat-defaults"
import {
	HighPriorityIcon,
	ALLOWED_FILE_SIZE_IN_MB as IMPORTED_ALLOWED_FILE_SIZE_IN_MB,
	LowPriorityIcon,
	MediumPriorityIcon,
	NoPriorityIcon,
	UrgentPriorityIcon,
} from "@productlane/ui"

export const ALLOWED_FILE_SIZE_IN_MB = IMPORTED_ALLOWED_FILE_SIZE_IN_MB
export const ALLOWED_POSTMARK_ATTACHMENTS_SIZE_IN_MB = 10

export const issueStatusOrder = [
	"backlog",
	"unstarted",
	"started",
	"completed",
	"canceled",
	"duplicate",
	"triage",
]

export const projectStatusOrder = [
	"backlog",
	"planned",
	"started",
	"paused",
	"completed",
	"canceled",
]

export const LinearPriorityIcon: Record<number, IconType> = {
	0: NoPriorityIcon,
	1: UrgentPriorityIcon,
	2: HighPriorityIcon,
	3: MediumPriorityIcon,
	4: LowPriorityIcon,
}

//https://stackoverflow.com/questions/386294/what-is-the-maximum-length-of-a-valid-email-address
export const EMAIL_MAXIMUM_LENGTH = 254
export const EMAIL_MAXIMUM_LENGTH_ERROR_MESSAGE =
	"Please enter a valid email address (maximum 254 characters)."

export const docsDefaultExampleQuestions = [...defaultAiChatExampleQuestions]

export const CHANGELOG_TITLE_MAXIMUM_LENGTH = 200

export const focusModeWidth = "(min-width: 1248px)"
